//@vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
// @components
const OKModal = require('components/commons/OKModal/OKModal');
// @constants
const WARNING_FISCAL_DATES = require('constants/brokerProviderWarningFiscalDates');

class BrokerHireAndContributionsModal extends React.Component {
    constructor(props){
        super(props)

        this.state = {
            shouldDisplay: true,
        }

        this.handleClosed = this.handleClosed.bind(this);
    }

    handleClosed(){
        this.props.history.goBack();
    }

    shouldDisplayComponent() {
        const { pensionPlanProvider } = this.props;

        const today = new Date ();
        const providerData = WARNING_FISCAL_DATES.providers.find(
            value => {
                return value.provider.includes(pensionPlanProvider);
            });
        const initialDate = providerData ? providerData.initialDate : WARNING_FISCAL_DATES.defaultProviderDates.initDate;
        const closeDate = providerData ? providerData.closeDate : WARNING_FISCAL_DATES.defaultProviderDates.closeDate;
        const shouldDisplay = (initialDate <= today) && (today <= closeDate)

        return shouldDisplay;
    }

    render(){

       if (this.shouldDisplayComponent()) {
           return (
               <OKModal
                   description="brokerAttentionPlanStartingModal-fiscalWarning"
                   descriptionAlignment="center"
                   footerType="action"
                   isOpen={this.state.shouldDisplay}
                   onCloseCallback={this.handleClosed}
                   onPrimaryButtonClick={this.handleClosed}
                   primaryButtonText="brokerAttentionPlanStartingModal-understood"
                   scrollable={false}
                   title="brokerAttentionPlanStartingModal-title"
                   titleAlignment="center"
                />
           )
       }
       return null;
    }
}

BrokerHireAndContributionsModal.propTypes = {
    history: PropTypes.object.isRequired,
    pensionPlanProvider: PropTypes.object.isRequired,
};

module.exports = withRouter(BrokerHireAndContributionsModal);
